import { Mail, Phone } from "lucide-react";

const team = [
  {
    name: "Nate Duncan",
    role: "Head of Procurement",
    email: "nate@alturasource.com",
    phone: "205.276.8151",
    bio: "15 Years in building materials space. Founded GC Sourcing and exited to Spraggins Group.",
    image: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/h9r177og_Screenshot%202026-04-08%20at%203.32.43%E2%80%AFPM.png"
  },
  {
    name: "Matt Laughlin",
    role: "Head of Construction",
    email: "matt@alturasource.com",
    phone: "205.213.6425",
    bio: "Previously VP of Construction at Heights Building and Director of Construction at GC Sourcing. Has turned over 10,000+ units.",
    image: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/v3t4b7ih_Screenshot%202026-04-08%20at%203.25.55%E2%80%AFPM.png"
  },
  {
    name: "Keshav Pandiri",
    role: "Head of Growth",
    email: "keshav@alturasource.com",
    phone: "678.549.9515",
    bio: "Background in development and value-add multifamily. Previously at Madison Capital, Brookfield Properties and PGIM.",
    image: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/m8bv6g1s_Screenshot%202026-04-08%20at%203.25.38%E2%80%AFPM.png"
  }
];

const TeamSection = () => {
  return (
    <section 
      id="team" 
      className="section-padding bg-slate-50"
      data-testid="team-section"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-cyan-600 font-semibold text-sm tracking-widest uppercase mb-4 block">
            Leadership
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mb-6">
            Meet Our{" "}
            <span className="text-cyan-600">Team</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Experienced leaders with deep expertise in real estate, construction, 
            procurement, and asset management.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {team.map((member, index) => (
            <div
              key={index}
              className="team-card bg-white rounded-lg overflow-hidden shadow-sm border border-slate-200"
              data-testid={`team-member-${index}`}
            >
              {/* Image */}
              <div className="aspect-square overflow-hidden bg-slate-100">
                <img
                  src={member.image}
                  alt={member.name}
                  className="team-image w-full h-full object-cover object-top"
                />
              </div>
              
              {/* Content */}
              <div className="p-6">
                <h3 className="text-lg font-bold text-slate-900 mb-1">
                  {member.name}
                </h3>
                <p className="text-cyan-600 font-medium text-sm mb-3">
                  {member.role}
                </p>
                <p className="text-slate-600 text-sm mb-4 line-clamp-3">
                  {member.bio}
                </p>
                
                {/* Contact */}
                <div className="flex items-center gap-3">
                  {member.email && (
                    <a
                      href={`mailto:${member.email}`}
                      className="w-8 h-8 bg-slate-100 rounded-full flex items-center justify-center hover:bg-cyan-100 hover:text-cyan-600 transition-colors"
                      data-testid={`team-email-${index}`}
                      title={member.email}
                    >
                      <Mail className="w-4 h-4" />
                    </a>
                  )}
                  {member.phone && (
                    <a
                      href={`tel:${member.phone.replace(/\./g, "")}`}
                      className="w-8 h-8 bg-slate-100 rounded-full flex items-center justify-center hover:bg-cyan-100 hover:text-cyan-600 transition-colors"
                      data-testid={`team-phone-${index}`}
                      title={member.phone}
                    >
                      <Phone className="w-4 h-4" />
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
